import { render, staticRenderFns } from "./QuickDashboard.vue?vue&type=template&id=adbaa83a&"
import script from "./QuickDashboard.vue?vue&type=script&lang=js&"
export * from "./QuickDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports